module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough-large.f7bd5c0c.png";